import { db } from "@/firebase/firebaseInit";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";

export default {
    async loadFeatureConfigurations(context) {
        onSnapshot(doc(db, "configurations", "features"), (doc) => {
            context.commit('setFeatureConfiguration', doc.data());
        });
    },
    async updateFeature(context, payload) {
        const featuresDocRef = doc(db, "configurations", "features");
        await updateDoc(featuresDocRef, { [payload.featureKey]: payload.newValue });
        console.log(`Updated ${payload.featureKey} to`, payload.newValue);
    }
}